import { Duration } from 'luxon';

import { ChartInterval, intervalToDuration } from '../types.ts';

export const getCappedForwardDuration = (interval: ChartInterval): Duration => {
  const baseDuration = Duration.fromObject(intervalToDuration[interval]);
  const maxForward = Duration.fromObject({ hours: 2 });

  if (baseDuration.as('hours') <= 6) {
    const bufferMillis = baseDuration.as('milliseconds') * 0.2;
    const buffer = Duration.fromMillis(bufferMillis);
    return buffer < maxForward ? buffer : maxForward;
  }

  return maxForward;
};
